<template lang="html">
<div v-show="!loadingProfile">
  <toolbar v-if="!propCompanyId" :title="toolbarTitle">
    <template v-if="hasFullAccess">
      <v-menu>
        <!--        <v-btn slot="activator" color="primary&#45;&#45;text">-->
        <l-toolbar-button slot="activator" label="Status" icon="verified_user"/>
        <v-list>
          <v-list-tile @click="showAddEmployeeDialog = true">
            <v-list-tile-action>
              <v-icon>person_add</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Add Employee or Driver</v-list-tile-title>
          </v-list-tile>

          <template v-if="isLtnAdmin">
            <v-list-tile v-if="accountSubmission"
                         @click="showOriginalSubmissionInfo = true">
              <v-list-tile-action>
                <v-icon>info_outline</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Original Account Submission</v-list-tile-title>
            </v-list-tile>

            <v-list-tile v-if="!isVerified" @click="showVerifyDialog = true">
              <v-list-tile-action>
                <v-icon>verified_user</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Verify</v-list-tile-title>
            </v-list-tile>

            <v-list-tile v-if="isDisabled"
                         @click="showReenableAccountDialog = true">
              <v-list-tile-action>
                <v-icon>report_off</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Re-enable Account</v-list-tile-title>
            </v-list-tile>

            <v-list-tile v-if="!isDisabled"
                         @click="showDisableAccountDialog = true">
              <v-list-tile-action>
                <v-icon>report</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Disable Account</v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="openConfirmDialog()" v-if="hasCertificate">
              <v-list-tile-action>
                <v-icon>check</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Confirm Insurance Certificate</v-list-tile-title>
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>

      <v-menu>
        <l-toolbar-button slot="activator" label="Tools" icon="link"/>
        <v-list>
          <v-list-tile @click="viewCompanyListings()">
            <v-list-tile-action>
              <v-icon>list</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Load Groups</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="viewCompanyBids()">
            <v-list-tile-action>
              <v-icon>attach_money</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Bids</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="viewCompanyDispatchedLoads()">
            <v-list-tile-action>
              <v-icon>share</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Dispatch Requests</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="viewCompanyLoads()">
            <v-list-tile-action>
              <v-icon>event</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Loads</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="viewCompanySettlement()">
            <v-list-tile-action>
              <v-icon>payment</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Transactions</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="isAdmin || isPermOffice || isPermCreateListing"
                       @click="$router.push({
                                name: 'post-load',
                                params: { id: company.id } })">
            <v-list-tile-action>
              <v-icon>add_circle_outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>Add New Load</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <l-toolbar-button icon="refresh" label="Reload" @click="loadCompany()" />
    </template>
  </toolbar>

    <confirm-insurance-modal v-model="showInsuranceModal" :company-id="_.get(company, 'id', null)">
    </confirm-insurance-modal>
    <v-dialog v-model="showAddEmployeeDialog"
              max-width="600"
              @input="v => v || restoreInviteForm()">
      <v-card class="pa-4">
        <v-layout column>
          <span class="title">Add Employee or Driver</span>
          <v-flex class="mt-2">
            <v-flex sm6>
              <v-text-field v-model="inviteEmail"
                            label="Contact Email"></v-text-field>
            </v-flex>
          </v-flex>
          <v-flex>
          <span class="subheadline accent--text">Permissions</span>
            <v-icon small @click="openPermissionsHelp = true" class="pl-3">help</v-icon>
          </v-flex>
          <v-layout row wrap>
            <v-flex sm6>
              <v-checkbox label="Admin"
                          v-model="permissions"
                          value="PERM_ADMIN"/>
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Receiving"
                          value="PERM_RECEIVING"
                          v-model="permissions"/>
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Financial"
                          value="PERM_FINANCIAL"
                          v-model="permissions"/>
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Office"
                          value="PERM_OFFICE"
                          v-model="permissions"/>
            </v-flex>
            <v-flex sm6>
<!--              <v-checkbox label="Buyer"-->
<!--                          value="PERM_CREATE_LISTING"-->
<!--                          v-model="permissions"/>-->
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Dispatched Driver"
                          value="PERM_DRIVER"
                          v-model="permissions"/>
            </v-flex>
            <v-flex sm6>
              <v-checkbox label="Direct Assign"
                          value="PERM_LOAD_ASSIGN"
                          v-if="isLtnAdmin"
                          v-model="permissions"/>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent" @click="sendInvite">Send Invite</v-btn>
            <v-btn color="accent" flat @click="showAddEmployeeDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="openPermissionsHelp" max-width="700">
      <v-card>
        <v-card-title class="lighten-2 py-3" primary-title>
          <v-flex>
            <h3>Employee Permissions</h3>
            <span>Brief explanation of user permissions</span>
          </v-flex>
          <v-btn icon color="primary" small
                 @click.native="openPermissionsHelp = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-data-table
          hide-actions
          :headers="permissionDescriptionHeaders"
          :items="permissionDescriptions">
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">
                <span class="subheading font-weight-bold">{{ props.item.name }}</span><br/>
                <span class="caption font-italic">{{ props.item.usage }}</span>
              </td>
              <td class="text-xs-left">{{ props.item.description }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showOriginalSubmissionInfo"
              max-width="600">
      <v-card class="pa-4">
        <v-layout column>
          <v-flex>
            <span class="subheading">Position at the company:</span>
            <span class="font-italic">{{accountSubmissionPosition}}</span>
          </v-flex>
          <v-flex>
            <span class="subheading">Company Focus:</span>
          </v-flex>
          <ul>
            <li v-for="(focus, focusIdx) in accountSubmissionCompanyFocus"
                :key="'focus-'+focusIdx">
              <span class="font-italic">{{focus}}</span>
            </li>
          </ul>
          <v-flex>
            <span class="subheading">Other information:</span>
            <span class="font-italic">{{accountSubmissionNotes}}</span>
          </v-flex>
          <v-flex>
            <span class="subsection-title font-italic">
              Originally submitted by: {{accountSubmissionContactName}}
              ({{accountSubmissionContactEmail}})
            </span>
          </v-flex>
          <v-flex>
            <span class="subsection-title font-italic">
              Originally submitted as: {{accountSubmissionCompanyName}}
            </span>
          </v-flex>
          <v-flex>
            <span class="subsection-title font-italic">
              Originally submitted phone: {{accountSubmissionPhone}}
            </span>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer />
          <v-btn color="accent" flat @click="showOriginalSubmissionInfo = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showVerifyDialog" max-width="600">
      <v-card class="pa-4">
        <v-layout column>
          <v-card-title class="px-0">
            Verifying means that the company will appear on listings and bids as a trusted company.
          </v-card-title>
          <v-textarea
            rows="3"
            v-model="dialogReason"
            label="Reason"
            :error-messages="errors.first('reason', 'verify')"
            data-vv-as="Reason"
            data-vv-name="reason"
            data-vv-scope="verify"
            v-validate="'required'"
            auto-grow>
          </v-textarea>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent"
                   :disabled="errors.any('verify')"
                   :loading="loadingBtn"
                   @click="verifyCompany">Mark Verified</v-btn>
            <v-btn color="accent" flat @click="showVerifyDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showDisableAccountDialog" max-width="600">
      <v-card class="pa-4">
        <v-layout column>
          <v-card-title class="px-0">
            Placing a company on hold means they can't list or bid on loads.
          </v-card-title>
          <v-textarea
            rows="3"
            v-model="dialogReason"
            label="Reason to place on hold"
            :error-messages="errors.first('reason', 'disable')"
            data-vv-as="Reason"
            data-vv-name="reason"
            data-vv-scope="disable"
            v-validate="'required'"
            auto-grow>
          </v-textarea>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent"
                   :disabled="errors.any('disable')"
                   :loading="loadingBtn"
                   @click="disableCompany">Place on Hold</v-btn>
            <v-btn color="accent" flat @click="showDisableAccountDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showReenableAccountDialog"
              max-width="600">
      <v-card class="pa-4">
        <v-layout column>
          <v-card-title class="px-0">
            Remove the hold from the company's account
          </v-card-title>
          <v-textarea
            rows="3"
            v-model="dialogReason"
            :error-messages="errors.first('reason', 'removeHold')"
            data-vv-as="Reason"
            data-vv-name="reason"
            data-vv-scope="removeHold"
            v-validate="'required'"
            label="Reason"
            auto-grow>
          </v-textarea>
          <v-card-actions>
            <v-spacer />
            <v-btn color="accent"
                   :disabled="errors.any('removeHold')"
                   :loading="loadingBtn"
                   @click="removeCompanyHold">Remove Hold</v-btn>
            <v-btn color="accent" flat @click="showReenableAccountDialog = false">Cancel</v-btn>
          </v-card-actions>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-layout column class="mt-2" v-if="isDisabled">
      <v-card class="py-2 pl-5" color="amber accent-4">
        <v-layout align-baseline>
          <div class="headline mr-3 mt-4 white-text">
            <v-icon color="white" large>report</v-icon> This account has a hold on it.
          </div>
          <span class="font-weight-regular white-text">{{companyDisabledReason}}</span>
        </v-layout>
      </v-card>
    </v-layout>

    <v-container style="overflow:auto" fluid>
    <v-card flat>
      <v-layout row>
        <v-flex xs-3>
          <v-navigation-drawer
            permanent
            floating>

            <v-list class="pt-0" dense>
              <v-list-tile
                v-for="item in companySettingsSections"
                :key="item.title"
                :to="`#${item.tabItemKey}`"
                @click="tab = item.tabItemKey"
              >
                <v-list-tile-action>
                  <v-icon :color="tab == item.tabItemKey ? 'primary' : ''">{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  <v-list-tile-sub-title class="font-italic font-weight-light">{{ item.subtitle }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-divider v-if="isLtnAdmin"/>

              <v-list-tile
                v-if="isLtnAdmin"
                v-for="item in siteAdminSettingsSections"
                :key="item.title"
                :to="`#${item.tabItemKey}`"
                @click="tab = item.tabItemKey"
              >
                <v-list-tile-action>
                  <v-icon :color="tab == item.tabItemKey ? 'primary' : ''">{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

          </v-navigation-drawer>
        </v-flex>

        <v-flex xs9 class="full-card-desktop" style="overflow:auto">
        <v-tabs-items v-model="tab">
          <v-tab-item value="contact_and_billing" lazy>
            <v-card class="py-2 pl-5">
              <v-layout align-baseline>
                <div class="title mr-3 mt-4">
                  Company Details
                </div>
              </v-layout>
              <v-layout column sm12 xs12 md6>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <v-flex sm12 xs12 md3 class="mr-5">
                    <v-text-field label="Company Name" :disabled="!isAdmin" v-model="companyName"/>
                  </v-flex>
                  <v-flex sm12 xs12 md3 class="mr-5">
                    <v-text-field label="Phone" :disabled="!isAdmin" v-model="contactPhone"/>
                  </v-flex>
                </v-layout>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <v-flex sm3 class="mr-5" v-if="isAdmin">
                    <v-text-field :label="einLabel" :disabled="!isAdmin" v-model="ein" />
                  </v-flex>
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Website URL" :disabled="!isAdmin" v-model="website"/>
                  </v-flex>
                </v-layout>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Contact Name" :disabled="!isAdmin" v-model="contactName"/>
                  </v-flex>
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Logo URL" :disabled="!isAdmin" v-model="logoUrl"/>
                  </v-flex>
                </v-layout>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Contact Email"
                                  :disabled="!isAdmin" v-model="contactEmail"/>
                  </v-flex>
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Billing Email"
                                  :disabled="!isAdmin" v-model="billingEmail"/>
                  </v-flex>
                </v-layout>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Night Contact Name"
                                  :disabled="!isAdmin"
                                  v-model="nightContactName"/>
                  </v-flex>
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Night Phone" :disabled="!isAdmin" v-model="nightPhone"/>
                  </v-flex>
                </v-layout>
              </v-layout>
              <v-layout align-baseline>
                <div class="title mr-3 mt-4">
                  Address
                </div>
              </v-layout>
              <v-layout column sm6>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Street"
                                  v-model="addressStreet1"
                                  :disabled="!isAdmin"/>
                  </v-flex>
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="City"
                                  v-model="addressCity"
                                  :disabled="!isAdmin"/>
                  </v-flex>
                </v-layout>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Suite or Building Number"
                                  v-model="addressStreet2"
                                  :disabled="!isAdmin"/>
                  </v-flex>
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="State"
                                  v-model="addressRegion"
                                  :disabled="!isAdmin"/>
                  </v-flex>
                </v-layout>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <v-flex sm3 class="mr-5">
                  </v-flex>
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Postal Code"
                                  v-model="addressPostalCode"
                                  :disabled="!isAdmin"/>
                  </v-flex>
                </v-layout>

                <v-layout :column="$vuetify.breakpoint.smAndDown"  align-baseline>
                  <div class="title mr-3 mt-4">
                    Billing Address

                    <v-btn class="accent" flat
                           v-if="_.get(company, 'producerInfo.billingAddress.label') && isAdmin"
                           @click="removeProducerInfo()">
                      <v-icon class="pr-2" color="white">cancel</v-icon>
                      Remove {{$t('booked-load.producer')}} Info
                    </v-btn>
                  </div>
                  <span sm3 class="pl-2 mr5">
                    Load {{$tc('booked-load.producers', 2).toLocaleLowerCase()}} provide a freight Billing Address and can post to the load
                    board.
                  </span>
                </v-layout>
                <v-layout :column="$vuetify.breakpoint.smAndDown" >
                  <span sm3 class="mr-5">
                    <v-checkbox v-model="copyAddress" label="Billing Address is same as above."
                                v-if="isAdmin"/>
                  </span>
                </v-layout>
                <v-layout column sm6
                          v-if="!copyAddress &&
                    company.producerInfo && company.producerInfo.billingAddress">
                  <v-layout :column="$vuetify.breakpoint.smAndDown" >
                    <v-flex sm3 class="mr-5">
                      <v-text-field label="Street 1"
                                    v-model="billingAddressStreet1"
                                    :disabled="!isAdmin"/>
                    </v-flex>
                    <v-flex sm3 class="mr-5">
                      <v-text-field label="City"
                                    v-model="billingAddressCity"
                                    :disabled="!isAdmin"/>
                    </v-flex>
                  </v-layout>
                  <v-layout :column="$vuetify.breakpoint.smAndDown" >
                    <v-flex sm3 class="mr-5">
                      <v-text-field label="Street 2"
                                    v-model="billingAddressStreet2"
                                    :disabled="!isAdmin"/>
                    </v-flex>
                    <v-flex sm3 class="mr-5">
                      <v-text-field label="State"
                                    v-model="billingAddressRegion"
                                    :disabled="!isAdmin"/>
                    </v-flex>
                  </v-layout>
                  <v-layout :column="$vuetify.breakpoint.smAndDown" >
                    <v-flex sm3 class="mr-5">
                    </v-flex>
                    <v-flex sm3 class="mr-5">
                      <v-text-field label="Postal Code"
                                    v-model="billingAddressPostalCode"
                                    :disabled="!isAdmin"/>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-layout>
              <v-layout>
                <v-flex sm3 class="mr-5">
                  <v-btn class="accent" v-if="isAdmin" @click="updateSettings">
                    Save
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>
          <v-tab-item value="loading_chutes" lazy>
            <!-- v-card -->
            <loading-chutes-section @refresh="loadCompany" v-if="company"
                                    :company="company" :is-admin="isAdmin">
            </loading-chutes-section>
          </v-tab-item>
          <v-tab-item value="trucking" lazy>
            <v-card class="py-2 pl-5 pr-5">
              <v-layout :column="$vuetify.breakpoint.smAndDown" align-baseline>
                <div class="title mr-3 mt-4">
                  Trucking Info

                  <v-btn class="accent" flat
                         v-if="truckingDotNumber && isAdmin"
                         @click="removeTruckingInfo()">
                    <v-icon class="pr-2" color="white">cancel</v-icon>
                    Remove
                  </v-btn>
                </div>
                <span sm3 class="pl-2 mr5">
                  Providing your Trucking Company's information allows you to bid on loads.
                </span>
              </v-layout>
              <v-layout column sm6 v-if="showTruckingCompanySection">
                <v-layout>
                  <v-flex sm3 class="mr-5">
                    <v-text-field label="Dot Number" :disabled="!isAdmin"
                                  v-model="truckingDotNumber"/>
                  </v-flex>
                </v-layout>
                <template v-if="hasFullAccess">
                  <v-layout >
                    <v-flex sm2 class="mr-5">
                      <upload-button class="cursor-pointer" :label="$t('company-profile.vendor-tax-document')"
                                     v-model="w9File" @files="w9FileUpload" />
                    </v-flex>
                    <v-flex v-if="_.get(company, 'truckingInfo.w9.link', false)" sm5
                            align-baseline class="mr-5 pt-2">
                      <v-btn flat
                             @click.prevent="openFile(company.truckingInfo.w9.link)">
                        {{company.truckingInfo.w9.name}}.pdf
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                  <span sm3 class="pl-2 mr5">
                    Your {{$t('company-profile.vendor-tax-document')}} is shared only with {{$t('booked-load.producer').toLocaleLowerCase()}} companies you haul for.
                  </span>
                  </v-layout>
                  <v-layout>
                    <v-flex sm2 class="mr-5">
                      <upload-button class="cursor-pointer" label="Insurance Policy"
                                     v-model="insuranceFile" @files="insuranceFileUpload" />
                    </v-flex>
                    <v-flex v-if="_.get(company, 'truckingInfo.insurancePolicy.link', false)"
                            sm5 class="mr-5">
                      <v-btn flat
                             @click.prevent="openFile(company.truckingInfo.insurancePolicy.link)">
                        {{company.truckingInfo.insurancePolicy.name}}.pdf
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <span sm3 class="pl-2 mr5">
                      Your Insurance Policy is shared with companies whose loads
                      you bid on or {{$t('booked-load.producer').toLocaleLowerCase()}} companies you haul for.
                    </span>
                  </v-layout>
                  <v-layout class="mt-3">
                    <v-btn @click="updateTruckingInfo" class="accent ml-0" v-if="isAdmin">
                      Save
                    </v-btn>
                  </v-layout>
                </template>
              </v-layout>
              <v-layout v-else-if="hasFullAccess">
                <v-btn class="accent" @click="showTruckingCompany = true" v-if="isAdmin">
                  <v-icon class="mr-2">add_circle</v-icon>
                  Add Trucking Company Details
                </v-btn>
              </v-layout>
            </v-card>
            <v-card v-if="hasFullAccess && showTruckingCompanySection" class="py-2 pl-5 pr-5 mt-3">
              <v-layout :column="$vuetify.breakpoint.smAndDown" align-baseline>
                <div class="title mr-3 mt-4">
                  Notify Insurance Company
                </div>
              </v-layout>
              <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-text-field label="Agent Name"
                                  data-vv-as="Agent Name"
                                  data-vv-name="agent"
                                  data-vv-scope="insurance"
                                  browser-autocomplete="off"
                                  v-validate="'required'"
                                  :error-messages="errors.first('agent', 'insurance')"
                                  v-model="insuranceAgent">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field label="Agent Email"
                                  data-vv-as="Agent Email"
                                  data-vv-name="email"
                                  data-vv-scope="insurance"
                                  browser-autocomplete="off"
                                  v-validate="'required|email'"
                                  :error-messages="errors.first('email', 'insurance')"
                                  v-model="insuranceEmail">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field label="Insurance Company"
                                  data-vv-as="Insurance Company"
                                  data-vv-name="company"
                                  data-vv-scope="insurance"
                                  v-validate="'required'"
                                  browser-autocomplete="off"
                                  :error-messages="errors.first('company', 'insurance')"
                                  v-model="insuranceCompany">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <p>
                    Look for an email with a subject "Insurance Certificate Request"
                    from "{{ $t('site-title.brief') }} Account Management": contact@livestocktransportnation.com
                  </p>
                </v-layout>

                <template v-if="hasCertificate">
                  <v-divider/>
                  <v-layout column class="mt-2">
                    <v-flex v-if="_.get(policyCertificate, 'requested', false)"
                            class="text-xs-left">
                      <b>Requested by: </b>
                      {{_.get(policyCertificate, 'requestedBy', '')}}
                      <i>
                        ({{_.get(policyCertificate, 'requestedByEmail', '')}})
                      </i>
                      <br/>
                      <b>Date: </b>
                      {{_.get(policyCertificate, 'requested', '') | formatDate}}
                      <br/>
                    </v-flex>
                    <v-flex v-if="_.get(policyCertificate, 'Confirmed', false)">
                      <b>Confirmed by: </b>
                      {{_.get(policyCertificate, 'confirmedBy', '')}}
                      <i>
                        ({{_.get(policyCertificate, 'confirmedByEmail', '')}})
                      </i>
                      <br/>
                      <b>Date: </b>
                      {{_.get(policyCertificate, 'confirmed', '') | formatDate}}
                      <br/>
                    </v-flex>
                    <v-flex v-if="_.get(policyCertificate, 'emailSent',false) &&
                     _.get(policyCertificate, 'emailSent', []).length" class="text-xs-left">
                      <div class="subheading mt-2 flex text-xs-left">
                        Emails sent to Agent:
                      </div>
                      <v-list-tile v-for="(item, index) in
                       _.get(policyCertificate, 'emailSent', [])"
                                   :key="`email_${index}`" avatar>
                        <v-list-tile-action>
                          <v-icon color="accent">email</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{item | formatDate}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-flex>
                  </v-layout>
                </template>

                <v-layout wrap>
                  <v-btn @click="notifyInsurance()"
                         :disabled="errors.any('insurance')"
                         :loading="loadingBtn"
                         class="accent ml-0 mr-3 my-0">
                    Save
                  </v-btn>

                  <template v-if="hasCertificate">
                    <v-btn @click="notifyInsurance()"
                           :disabled="errors.any('insurance')"
                           :loading="loadingBtn"
                           class="primary ml-0 mr-3 my-0">
                      Remind Agent
                    </v-btn>

                    <v-btn @click="openConfirmDialog()"
                           v-if="isLtnAdmin"
                           class="accent ml-0 mr-3 my-0">
                      Confirm Insurance Certificate
                    </v-btn>
                  </template>

                </v-layout>
              </v-container>
            </v-card>
          </v-tab-item>
          <!--v-tab-item key="Payment" v-if="isAdmin">
            <payment-methods-section v-if="company && company.id" :company="company">
            </payment-methods-section>
          </v-tab-item -->
          <v-tab-item key="Invoicing" value="invoicing" lazy v-if="hasFullAccess">
            <v-layout align-baseline>
              <invoicing-section @refresh="loadCompany" v-if="company && company.id" :company="company">

              </invoicing-section>
            </v-layout>
          </v-tab-item>
          <v-tab-item key="Load Defaults" value="load_defaults" lazy v-if="hasFullAccess">
            <checklist-section @refresh="loadCompany" v-if="company && company.id" :company="company">
            </checklist-section>
          </v-tab-item>
          <v-tab-item key="AdminTools" value="admin_tools" v-if="isLtnAdmin" lazy>
            <v-card class="py-2 pb-4 pl-5 pr-5 mt-3">
              <v-layout align-baseline>
                <div class="title mr-3 mt-4">
                  Company Load Code
                </div>
                <span sm3 class="pl-2 mr5">
                  In the event this company got a wrong or inappropriate code.
                </span>
              </v-layout>
              <v-layout column sm6 class="mt-3">
                <v-flex sm6>
                  <v-text-field v-model="companyCode"
                                label="Company Code"></v-text-field>
                  <v-btn color="accent" @click="updateCompanyCode">Update</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-tab-item>
          <v-tab-item value="timeline" v-if="isLtnAdmin" lazy>
            <v-card v-if="isLtnAdmin" class="pt-2 pb-4 pl-5 pr-5 mt-3">
              <v-layout align-baseline>
                <div class="title mr-3 mt-4">
                  Account History <v-icon @click="loadTimeline()">refresh</v-icon>
                </div>
              </v-layout>

              <v-layout class="mt-2" wrap justify-start>
                <v-flex sm12 md8>
                  <v-textarea block v-model="msgText"
                              :rows="2"
                              label="Type something...">
                  </v-textarea>
                </v-flex>
                <v-flex sm12 md2 class="px-1">
                  <v-btn block class="mr-1 px-0"
                         :loading="loadingBtn"
                         :disabled="loadingBtn"
                         @click="sendMessage">
                    Send
                  </v-btn>
                </v-flex>
              </v-layout>
              <timeline v-if="timeline"
                        showTime
                        :timeline-object="timeline"></timeline>
            </v-card>
          </v-tab-item>
          <v-tab-item value="permissions" v-if="hasFullAccess" lazy>
            <v-card elevation="1">
              <employees-section @refresh="loadCompany"
                                 @add-new="showAddEmployeeDialog = true"
                                 v-if="company && company.id"
                                 :company="company" :is-admin="isAdmin">
              </employees-section>

              <invitations-section v-if="isAdmin && company && company.id"
                                   @refresh="loadCompany"
                                   :company="company">
              </invitations-section>
            </v-card>
          </v-tab-item>
          <v-tab-item value="dispatching" v-if="hasFullAccess" lazy>
            <dispatching-info-section v-if="company && company.id" :company="company">
            </dispatching-info-section>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-layout>
  </v-card>
  </v-container>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import _ from 'lodash';
import API from '@/api';
import Toolbar from '@/components/Toolbar';
import UploadButton from '@/components/UploadButton';
import AddressSearch from '@/components/AddressSearch';
import Timeline from '@/components/timeline/Timeline';
import { mapState, mapGetters } from 'vuex';
import * as types from '@/store/mutationTypes';
import * as Companies from '@/types/models/company';
import {
  accountHasCreateListingPermission,
  accountHasOfficePermission,
  accountHasAdminPermission,
} from '@/store/permissions';

import FeatureFlagsMixin from '@/mixins/featureFlagMixin';
import QuickbooksMixin from '@/mixins/quickbooksMixin';
import XeroMixin from '@/mixins/xeroMixin';

import InvitationsSection from './Sections/InvitationsSection';
import DispatchingInfoSection from './Sections/DispatchingInfoSection';
import PaymentMethodsSection from './Sections/PaymentMethodsSection';
import EmployeesSection from './Sections/EmployeesSection';
import LoadingChutesSection from './Sections/LoadingChutesSection';
import ConfirmInsuranceModal from '../../components/modals/ConfirmInsuranceModal';
import QuickbooksSection from './Sections/QuickbooksSection';
import InvoicingSection from './Sections/InvoicingSection.vue';
import ChecklistSection from './Sections/ChecklistSection.vue';
import LToolbarButton from '../../components/ToolbarButton.vue';

const { mapFields } = createHelpers({
  getterType: 'companies/getField',
  mutationType: 'companies/updateField',
});

export default {
  name: 'CompanySettings',
  mixins: [
    FeatureFlagsMixin,
    QuickbooksMixin,
    XeroMixin,
  ],
  props: {
    propCompanyId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data: () => ({
    w9File: null,
    w9FileData: null,
    insuranceFile: null,
    insuranceFileData: null,
    showAddEmployeeDialog: false,
    showInsuranceModal: false,
    inviteEmail: null,
    permissions: [],
    selectedCarrier: null,
    copyAddress: false,
    employee: null,
    showTruckingCompany: false,
    openPermissionsHelp: false,
    showOriginalSubmissionInfo: false,
    showVerifyDialog: false,
    showDisableAccountDialog: false,
    showReenableAccountDialog: false,
    dialogReason: '',
    timeline: null,
    msgText: '',
    loadingBtn: false,
    hasCertificate: false,
    tab: null,
    drawer: {
      open: true,
      mini: false,
      permanent: true,
    },

  }),
  beforeRouteUpdate(to, from, next) {
    if (to.path !== from.path) {
      this.w9File = null;
      this.insuranceFile = null;
      this.loadCompany(to.params.id);
    }
    next();
  },
  components: {
    LToolbarButton,
    ChecklistSection,
    InvoicingSection,
    ConfirmInsuranceModal,
    Toolbar,
    PaymentMethodsSection,
    UploadButton,
    AddressSearch,
    Timeline,
    InvitationsSection,
    DispatchingInfoSection,
    EmployeesSection,
    LoadingChutesSection,
    QuickbooksSection,
  },
  watch: {
    $route() { // Reset form
      this.w9File = null;
      this.insuranceFile = null;
    },
    'company.id': function () {
      this.hasCertificate = !_.isEmpty(_.get(this.company, 'truckingInfo.insurancePolicyCertificate.agent', {}));
    },
  },
  computed: {
    _() {
      return _;
    },
    ...mapState('profiles', {
      userProfile: 'userProfile',
    }),
    ...mapState('companies', {
      companies: 'companies',
      company: 'profileCompany',
      loadingProfile: 'loadingProfile',
    }),
    ...mapGetters('profiles', {
      isLtnAdmin: 'isLtnAdmin',
    }),
    ...mapFields({
      companyName: 'profileCompany.companyName',
      contactPhone: 'profileCompany.contactPhone',
      nightContactName: 'profileCompany.nightContactName',
      nightPhone: 'profileCompany.nightPhone',
      ein: 'profileCompany.ein',
      contactEmail: 'profileCompany.contactEmail',
      billingEmail: 'profileCompany.billingEmail',
      logoUrl: 'profileCompany.logoUrl',
      contactName: 'profileCompany.contactName',
      website: 'profileCompany.website',
      addressLabel: 'profileCompany.companyAddress.label',
      addressCity: 'profileCompany.companyAddress.city',
      addressPlaceId: 'profileCompany.companyAddress.googlePlaceId',
      addressPostalCode: 'profileCompany.companyAddress.postalCode',
      addressRegion: 'profileCompany.companyAddress.region',
      addressStreet1: 'profileCompany.companyAddress.street1',
      addressStreet2: 'profileCompany.companyAddress.street2',
      billingAddressLabel: 'profileCompany.producerInfo.billingAddress.label',
      billingAddressCity: 'profileCompany.producerInfo.billingAddress.city',
      billingAddressPostalCode: 'profileCompany.producerInfo.billingAddress.postalCode',
      billingAddressRegion: 'profileCompany.producerInfo.billingAddress.region',
      billingAddressStreet1: 'profileCompany.producerInfo.billingAddress.street1',
      billingAddressStreet2: 'profileCompany.producerInfo.billingAddress.street2',
      truckingDotNumber: 'profileCompany.truckingInfo.dotNumber',
      companyCode: 'profileCompany.code',
      insuranceAgent: 'profileCompany.truckingInfo.insurancePolicyCertificate.agent.agentName',
      insuranceEmail: 'profileCompany.truckingInfo.insurancePolicyCertificate.agent.agentEmail',
      insuranceCompany: 'profileCompany.truckingInfo.insurancePolicyCertificate.agent.insuranceCompany',
    }),
    isTruckingCompany() {
      return Companies.isTruckingCompany(this.company);
    },
    policyCertificate() {
      return _.get(this.company, 'truckingInfo.insurancePolicyCertificate', null);
    },
    hasFullAccess() {
      return this.isLtnAdmin || this.isPermOffice || this.isCompanyAdmin;
    },
    userAccountCompany() {
      return this.findCompanyAccount()(this.company.id);
    },
    isPermCreateListing() {
      return accountHasCreateListingPermission(this.userAccountCompany);
    },
    isPermOffice() {
      return accountHasOfficePermission(this.userAccountCompany);
    },
    isCompanyAdmin() {
      return accountHasAdminPermission(this.userAccountCompany);
    },
    isAdmin() { // App or Company admin
      return this.isLtnAdmin || this.isCompanyAdmin;
    },
    showTruckingCompanySection() {
      return this.showTruckingCompany || this.truckingDotNumber || false;
    },
    permissionDescriptionHeaders() {
      return [
        { text: 'Permission', name: 'permission', sortable: false, align: 'left' },
        { text: 'Description', name: 'description', sortable: false, align: 'left' },
        // { text: 'Usage', name: 'usage', sortable: false, align: 'left' },
      ];
    },
    permissionDescriptions() {
      const permissions = [
        {
          name: 'Admin',
          usage: 'All Companies',
          description: 'Company Administrators can do everything on behalf of the company. They are also the only users who can make changes to the Company Profile.',
        },
        {
          name: 'Office',
          // TODO: figure out how to use i18n in scripts
          usage: 'Load Producers',
          description: 'Company Office staff users can post load listings to the load board, place and accept bids, produce loads as “Dispatch to CDN” as well as accept dispatch load requests, see all current and past booked loads, participate in load history conversation, and follow up on payment settlement.',
        },
        // {
        //   name: 'Buyer',
        // TODO: figure out how to use i18n in scripts
        //   usage: 'Load Producers',
        //   description: 'This user is a commissioned buyer who is trying to line up trucks on behalf of the company by posting listings on the load board to be bid.',
        // },
        {
          name: 'Financial',
          usage: 'Trucking Companies',
          description: 'This user has visibility into the business as an accountant or bookkeeper. Cannot accept bids, but everything else a Scheduler does.',
        },
        {
          name: 'Dispatched Driver',
          usage: 'Trucking Companies',
          description: 'Dispatched drivers don\'t have any permissions within the company.  They move their assigned loads through the workflow and communicate on the fulfillment timeline. They don\'t have visibility into anything else.',
        },
        {
          name: 'Receiving',
          usage: 'Stockyards',
          description: 'Stockyard Receivers assist loading and unloading trucks, and communicate on a load\'s fulfillment timeline leaving from or arriving to the stockyard, and have visibility into current and inbound loads.  Once a load is delivered, it no longer shows on the receiving dashboard. They have no visibility into bid history or pricing.',
        },
      ];

      if (this.isLtnAdmin) {
        permissions.push(
          {
            name: 'Direct Assign',
            usage: 'Trucking Companies',

            description: `A trucking company can allow a load producer to add loads to their board, bypassing the bidding process.  This should only be done with great care; this also requires ${this.$t('site-title.brief')} approval and setup between the two companies to work.`,
          },
        );
      }

      return permissions;
    },
    isVerified() {
      return !_.isEmpty(this.companyVerifiedDate);
    },
    isDisabled() {
      return !_.isEmpty(this.companyDisabledSince);
    },
    companyStatus() {
      return _.get(this.company, 'accountStatus');
    },
    companyVerifiedDate() {
      return _.get(this.companyStatus, 'verified');
    },
    companyDisabledSince() {
      return _.get(this.companyStatus, 'disabledSince');
    },
    companyDisabledReason() {
      return _.get(this.companyStatus, 'disabledReason');
    },
    accountSubmission() {
      return _.get(this.company, 'accountRequest');
    },
    accountSubmissionCompanyFocus() {
      return _.get(this.accountSubmission, 'companyType');
    },
    accountSubmissionPosition() {
      return _.get(this.accountSubmission, 'companyPosition');
    },
    accountSubmissionContactName() {
      return _.get(this.accountSubmission, 'name');
    },
    accountSubmissionCompanyName() {
      return _.get(this.accountSubmission, 'companyName');
    },
    accountSubmissionPhone() {
      return _.get(this.accountSubmission, 'phone');
    },
    accountSubmissionNotes() {
      return _.get(this.accountSubmission, 'notes');
    },
    accountSubmissionContactEmail() {
      return _.get(this.accountSubmission, 'email');
    },
    einLabel() {
      return this.isVerified ? 'EIN' : 'EIN (Unverified)';
    },
    toolbarTitle() {
      let sectionLabel = '';
      if (this.tab){
        const section = this.companySettingsSectionsByTab[this.tab];
        sectionLabel = `: ${section.title}`;
      }
      return `${this.company.companyName} ${sectionLabel}`;
    },
    companySettingsSectionsByTab() {
      const sections = _.concat(this.companySettingsSections, this.siteAdminSettingsSections);
      return _.keyBy(sections, 'tabItemKey');
    },
    companySettingsSections() {
      return [
        {
          title: 'Company',
          subtitle: 'contacts and billing',
          tabItemKey: 'contact_and_billing',
          icon: 'contact_mail',
        }
        ,{
          title: 'Team',
          subtitle: 'team, permissions, and drivers',
          tabItemKey: 'permissions',
          icon: 'groups',
        }
        ,{
          title: 'Outside Dispatching',
          tabItemKey: 'dispatching',
          icon: 'share',
        }
        ,{
          title: 'Invoicing',
          subtitle: 'bookkeeping connectors',
          tabItemKey: 'invoicing',
          icon: 'receipt_long',
        }
        ,{
          title: 'Facility Instructions',
          subtitle: 'approach instructions',
          tabItemKey: 'loading_chutes',
          icon: 'add_road',
        }
        ,{
          title: 'Load Defaults',
          tabItemKey: 'load_defaults',
          icon: 'assignment_turned_in',
        }
        ,{
          title: 'Trucking',
          subtitle: 'DOT and insurance',
          tabItemKey: 'trucking',
          icon: 'local_shipping',
        }
      ];
    },
    siteAdminSettingsSections() {
      return [
        {
          title: 'Admin Tools',
          tabItemKey: 'admin_tools',
          icon: 'admin_panel_settings',
          hide: !this.isLtnAdmin
        }
        ,{
          title: 'Timeline',
          tabItemKey: 'timeline',
          icon: 'show_chart',
          hide: !this.isLtnAdmin
        }
      ];
    },
  },
  methods: {
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
    openConfirmDialog() {
      this.showInsuranceModal = true;
    },
    async notifyInsurance() {
      try {
        const isValid = await this.$validator.validateAll('insurance');
        if (isValid) {
          this.loadingBtn = true;

          await API.company.notifyInsuranceCarrier({
            companyId: this.company.id,
            body: {
              agentName: this.insuranceAgent,
              insuranceCompany: this.insuranceCompany,
              agentEmail: this.insuranceEmail,
            },
          });

          this.loadCompany();
          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Insurance company notified',
            timeout: 7000,
          });
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.loadingBtn = false;
      }
    },
    resetAddressField() {
      this.locationPlaceId = null;
    },
    async sendMessage() {
      try {
        await API.company.addHistoryComment({
          companyId: this.company.id,
          message: {
            message: this.msgText,
            sent: new Date().toISOString(),
          },
        });

        this.msgText = '';
        this.loadTimeline();
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'Comment not saved',
        });
      }
    },
    async updateCompanyCode() {
      try {
        await API.company.updateCompanyCode({
          companyId: this.company.id,
          codeUpdate: {
            code: this.companyCode,
          },
        });

        this.loadCompany();
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'Company Code not saved',
        });
      }
    },
    async removeTruckingInfo() {
      const confirmation = await this.$confirm('Do you really want to remove trucking info?');
      if (!confirmation) {
        return;
      }

      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await API.company.removeTruckingInfo({ companyId: this.company.id });
        this.loadCompany();
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Company updated',
          timeout: 7000,
        });
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async removeProducerInfo() {
      const producer = this.$t('booked-load.producer').toLocaleLowerCase();
      const prompt = `Do you really want to remove ${producer} billing info?`;
      const confirmation = await this.$confirm(prompt);
      if (!confirmation) {
        return;
      }

      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await API.company.removeProducerInfo({ companyId: this.company.id });
        this.loadCompany();
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Company updated',
          timeout: 7000,
        });
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    w9FileUpload(file) {
      this.w9FileData = file[0];
    },
    insuranceFileUpload(file) {
      this.insuranceFileData = file[0];
    },
    async openFile(link) {
      this.$store.commit(`applications/${types.START_LOADING}`);
      const response = await API.application.getDocument({ url: link });
      const url = window.URL.createObjectURL(response);
      window.open(url, '_self');
      this.$store.commit(`applications/${types.END_LOADING}`);
    },
    async updateTruckingInfo() {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await API.company.addTruckingInfo({
          companyId: this.company.id,
          body: {
            dotNumber: this.company.truckingInfo.dotNumber,
          },
        });

        if (this.w9FileData) {
          const w9Base64File = await this.getBase64(this.w9FileData);
          await API.company.addW9Files({
            companyId: this.company.id,
            body: {
              pages: [{
                base64EncodedData: w9Base64File,
              }],
            },
          });
          this.w9FileData = null;
          this.w9File = null;
        }

        if (this.insuranceFileData) {
          const base64File = await this.getBase64(this.insuranceFileData);
          await API.company.addInsurancePolicy({
            companyId: this.company.id,
            body: {
              pages: [{
                base64EncodedData: base64File,
              }],
            },
          });
          this.insuranceFileData = null;
          this.insuranceFile = null;
        }

        this.loadCompany();
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Company updated',
          timeout: 7000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async updateSettings() {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await API.company.update({ company: this.company });
        await API.company.addProducerInfo({
          companyId: this.company.id,
          body: this.copyAddress ?
            { billingAddress: this.company.companyAddress } : this.company.producerInfo,
        });
        this.loadCompany();
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Company updated',
          timeout: 7000,
        });
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    restoreInviteForm() {
      this.permissions = [];
      this.inviteEmail = null;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    async sendInvite() {
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        await API.company.sendInvite({
          companyId: this.company.id,
          body: { emailAddress: this.inviteEmail, permissions: this.permissions },
        });
        this.showAddEmployeeDialog = false;

        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Invite Sent',
          timeout: 7000,
        });
        this.restoreInviteForm();
        this.loadCompany();
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: error.message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
    async disableCompany() {
      const isValid = await this.$validator.validateAll('disable');
      if (isValid) {
        try {
          this.loadingBtn = true;
          await API.company.placeHoldOnAccount({
            id: this.company.id,
            status: { reason: this.dialogReason },
          });
          this.showDisableAccountDialog = false;
          this.dialogReason = '';

          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Account Disabled',
            timeout: 7000,
          });
          this.loadCompany();
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        } finally {
          this.loadingBtn = false;
        }
      }
    },
    async removeCompanyHold() {
      const isValid = await this.$validator.validateAll('removeHold');
      if (isValid) {
        try {
          this.loadingBtn = true;
          await API.company.removeHoldFromAccount({
            id: this.company.id,
            status: { reason: this.dialogReason },
          });
          this.showReenableAccountDialog = false;
          this.dialogReason = '';

          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Account Re-enabled by removing hold',
            timeout: 7000,
          });
          this.loadCompany();
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        } finally {
          this.loadingBtn = false;
        }
      }
    },
    async verifyCompany() {
      const isValid = await this.$validator.validateAll('verify');
      if (isValid) {
        try {
          this.loadingBtn = true;
          await API.company.verifyAccount({
            id: this.company.id,
            status: { reason: this.dialogReason },
          });
          this.showVerifyDialog = false;
          this.dialogReason = '';

          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Account Verified',
            timeout: 7000,
          });
          this.loadCompany();
        } catch (error) {
          this.$store.dispatch('applications/setErrorNotification', {
            message: error.message,
          });
        } finally {
          this.loadingBtn = false;
        }
      }
    },
    async loadTimeline(companyId) {
      const apiResponse = await API.company.timeline({
        companyId: companyId || this.$route.params.id,
      });
      this.timeline = apiResponse.data;
    },
    viewCompanyListings() {
      const companyId = _.get(this.company, 'id');
      this.$router.push({ name: 'company.listings', params: { id: companyId } });
    },
    viewCompanyBids() {
      const companyId = _.get(this.company, 'id');
      this.$router.push({ name: 'company.placed-bids', params: { id: companyId } });
    },
    viewCompanyDispatchedLoads() {
      const companyId = _.get(this.company, 'id');
      this.$router.push({ name: 'company.dispatched-loads', params: { id: companyId } });
    },
    viewCompanyLoads() {
      const companyId = _.get(this.company, 'id');
      this.$router.push({ name: 'company.loads.scheduled', params: { id: companyId } });
    },
    viewCompanySettlement() {
      const companyId = _.get(this.company, 'id');
      this.$router.push({ name: 'company.load-settlement', params: { id: companyId } });
    },
    viewCompanyHistory() {
      const companyId = _.get(this.company, 'id');
      this.$router.push({ name: 'company.history', params: { id: companyId } });
    },
    async loadCompany(companyId) {
      if (this.company && this.isQuickbooksConnected(this.company)){
        this.loadCompanyQuickbooksInfo(this.company.id);
      }
      if (this.company && this.isXeroConnected(this.company)){
        this.loadCompanyXeroInfo(this.company.id);
      }

      this.$store.dispatch('applications/addLoading', [
        this.$store.dispatch('companies/getProfileCompany', { id: companyId || this.$route.params.id }),
      ]);

      if (this.isLtnAdmin) {
        this.loadTimeline(companyId);
      }
    },
  },
  created() {
    window.__insp.push(['tagSession', 'access_company_profile']);
    this.loadCompany(this.propCompanyId);
  },
};
</script>

<style lang="css" scoped>
.white-text{
  color: white;
}
.custom-drawer {
  z-index: 0;
}

.full-card-desktop {
  height: calc(100vh - 200px);
  overflow: auto;
}

.tall-title {
  height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Companies/Settings.vue